import { Injectable , inject } from '@angular/core';

/** ====Addins=== */
import { CanActivate , CanActivateFn , Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

/**=== services  */
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
class PermissionsService {

  constructor(
    private router: Router,
    private authService : AuthService,
    ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      //your logic goes here
      let result = await this.authService.isLoggedIn();

      if( !result ){
        this.router.navigate(['/signin']);
      }
      return result;
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return inject(PermissionsService).canActivate(next, state);
}
